import React, { useMemo } from 'react';
import { ListItemButton, ListItemIcon, ListItemText, Box } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';

const SidebarNavItem = ({ open, icon, text, active, onClick }) => {
  const theme = useTheme();

  const COLORS = useMemo(
    () => ({
      text: theme.palette.text.primary,
      textMuted: theme.palette.text.secondary,
      accent: theme.palette.primary.main,
      hover: theme.palette.action.hover,
      activeBg: alpha(theme.palette.primary.main, 0.12),
      activeOutline: alpha(theme.palette.primary.main, 0.28),
      activeGlow: alpha(theme.palette.primary.main, 0.22),
    }),
    [theme]
  );

  return (
    <ListItemButton
      onClick={onClick}
      sx={{
        position: 'relative',
        mx: 1.0,
        mb: 0.4,          // tighter
        borderRadius: 1.25,
        px: open ? 1.25 : 1.0,
        py: 0.85,         // tighter
        minHeight: 38,
        color: COLORS.text,
        transition: 'background .18s ease, box-shadow .18s ease, transform .12s ease',
        '&:hover': {
          backgroundColor: COLORS.hover,
        },
        ...(active && {
          backgroundColor: COLORS.activeBg,
          boxShadow: `inset 0 0 0 1px ${COLORS.activeOutline}, 0 10px 22px -18px ${COLORS.activeGlow}`,
        }),
        '&:active': { transform: 'scale(0.99)' },
      }}
    >
      {/* left active bar */}
      <Box
        sx={{
          position: 'absolute',
          left: 6,
          top: 8,
          bottom: 8,
          width: 3,
          borderRadius: 2,
          backgroundColor: active ? COLORS.accent : 'transparent',
          transition: 'background .18s ease',
        }}
      />

      <ListItemIcon
        sx={{
          color: active ? COLORS.accent : COLORS.textMuted,
          minWidth: 'unset',
          mr: open ? 1.1 : 0,
          ml: 1.1,
          '& svg': { fontSize: 20 },
        }}
      >
        {icon}
      </ListItemIcon>

      {open && (
        <ListItemText
          primary={text}
          primaryTypographyProps={{
            fontSize: 13.5,
            fontWeight: active ? 700 : 550,
            letterSpacing: 0.2,
          }}
        />
      )}
    </ListItemButton>
  );
};

export default SidebarNavItem;
